import { __extends } from "tslib";
import classnames from 'classnames';
import React, { Component } from 'react';
import "../../../style/components/dropDownList.scss";
var DropDownList = (function (_super) {
    __extends(DropDownList, _super);
    function DropDownList(props) {
        var _this = _super.call(this, props) || this;
        _this.select = function (listItem) {
            var itemSelectedCallback = _this.props.itemSelectedCallback;
            if (itemSelectedCallback) {
                itemSelectedCallback(listItem);
            }
        };
        _this.show = function () {
            var list = _this.props.list;
            if (list && list.size > 0) {
                _this.setState({
                    listVisible: true,
                });
                document.addEventListener('click', _this.hide);
            }
        };
        _this.hide = function () {
            _this.setState({
                listVisible: false,
            });
            document.removeEventListener('click', _this.hide);
        };
        _this.state = {
            listVisible: false,
        };
        return _this;
    }
    DropDownList.prototype.render = function () {
        var listVisible = this.state.listVisible;
        var _a = this.props, list = _a.list, disabled = _a.disabled, selected = _a.selected, defaultLabel = _a.defaultLabel;
        var title = selected && list ? list.get(selected) : defaultLabel;
        return (React.createElement("div", { className: classnames({
                'rb-dropdown-container': true,
                'rb-show-list': listVisible,
            }) },
            React.createElement("div", { className: classnames({
                    'rb-dropdown-display': true,
                    clicked: listVisible,
                    disabled: disabled || !list || list.size === 0,
                }), onClick: this.show },
                React.createElement("div", { className: 'rb-selection-title' }, title),
                React.createElement("div", { className: 'rb-selection-icon' },
                    React.createElement("div", { className: 'rb-dropdown-icon' }))),
            React.createElement("div", { className: 'rb-dropdown-list' },
                React.createElement("div", null, this.renderListItems()))));
    };
    DropDownList.prototype.renderListItems = function () {
        var _this = this;
        var _a = this.props, list = _a.list, disabled = _a.disabled;
        var items = [];
        if (!disabled && list && list.size > 0) {
            list.forEach(function (itemLabel, itemValue) {
                items.push((React.createElement("div", { className: 'rb-dropdown-item', key: itemValue, onClick: function () { return _this.select(itemValue); } }, itemLabel)));
            });
        }
        return items;
    };
    return DropDownList;
}(Component));
export { DropDownList };
